var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133.404,
    height: 90.918,
    viewBox: "0 0 133.404 90.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_41",
    "data-name": "Ret\\xE2ngulo 41",
    width: 133.404,
    height: 90.918,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_40",
    "data-name": "Ret\\xE2ngulo 40",
    width: 133.404,
    height: 90.919,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_38",
    "data-name": "Ret\\xE2ngulo 38",
    width: 96.724,
    height: 46.84,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_39",
    "data-name": "Ret\\xE2ngulo 39",
    width: 7.973,
    height: 49.705,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_127",
    "data-name": "Grupo 127",
    opacity: 0.661
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_126",
    "data-name": "Grupo 126",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_125",
    "data-name": "Grupo 125",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_124",
    "data-name": "Grupo 124",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_281",
    "data-name": "Caminho 281",
    d: "M62.787.977a6.25,6.25,0,0,1,1.869,1.744l.249.249,48.834,77.858a6.475,6.475,0,0,1-2.118,8.969,7.054,7.054,0,0,1-3.114,1H33.014A1.515,1.515,0,0,1,31.519,89.3a1.5,1.5,0,0,1,1.37-1.495h75.244a3.515,3.515,0,0,0,1.869-.5,3.58,3.58,0,0,0,1.246-4.485l-.125-.249L62.288,4.714a4.733,4.733,0,0,0-1.121-1.121,3.512,3.512,0,0,0-4.609.872l-.123.249L7.6,82.572a3,3,0,0,0-.5,1.869A3.246,3.246,0,0,0,10.341,87.8H16.2A1.515,1.515,0,0,1,17.691,89.3a1.5,1.5,0,0,1-1.37,1.495H10.466a6.513,6.513,0,0,1-6.478-6.478A5.351,5.351,0,0,1,4.86,81.2l.249-.374L53.817,3.094A6.5,6.5,0,0,1,62.787.977M27.781,87.8A1.515,1.515,0,0,1,29.276,89.3a1.5,1.5,0,0,1-1.37,1.495l-.125.125H20.805a1.515,1.515,0,0,1-1.495-1.495,1.5,1.5,0,0,1,1.372-1.495h7.1Z",
    transform: "translate(0.98 0)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_120",
    "data-name": "Grupo 120",
    transform: "translate(11.945 38.099)",
    opacity: 0.151
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_119",
    "data-name": "Grupo 119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_118",
    "data-name": "Grupo 118",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_282",
    "data-name": "Caminho 282",
    d: "M96.666,60.357l9.468,15.2a1.342,1.342,0,0,1-.374,1.744,1.123,1.123,0,0,1-.623.125h-94.3a1.177,1.177,0,0,1-1.246-1.246,5.444,5.444,0,0,1,.123-.623L37.618,30.584A75.477,75.477,0,0,0,96.666,60.357",
    transform: "translate(-9.588 -30.584)",
    fill: "#7a7a7a",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_123",
    "data-name": "Grupo 123",
    transform: "translate(56.293 26.265)",
    opacity: 0.151
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_122",
    "data-name": "Grupo 122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_121",
    "data-name": "Grupo 121",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_283",
    "data-name": "Caminho 283",
    d: "M49.176,62.816a3.986,3.986,0,1,1,0,7.973A4.1,4.1,0,0,1,45.188,66.8a4.015,4.015,0,0,1,3.988-3.986m0-41.732a4.015,4.015,0,0,1,3.986,3.986V52.476a4.014,4.014,0,0,1-3.986,3.986,4.1,4.1,0,0,1-3.988-3.986V25.07a4.015,4.015,0,0,1,3.988-3.986",
    transform: "translate(-45.189 -21.084)",
    fill: "#7a7a7a",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_284",
    "data-name": "Caminho 284",
    d: "M49.495,61.616a5.606,5.606,0,1,1-5.606,5.606,5.662,5.662,0,0,1,5.606-5.606m0,3.114a2.491,2.491,0,1,0,2.491,2.491,2.423,2.423,0,0,0-2.491-2.491m0-44.846A5.582,5.582,0,0,1,55.1,25.49V52.9a5.606,5.606,0,1,1-11.212,0V25.49a5.662,5.662,0,0,1,5.606-5.606m0,3.114A2.5,2.5,0,0,0,47,25.49V52.9a2.491,2.491,0,1,0,4.983,0V25.49A2.423,2.423,0,0,0,49.495,23",
    transform: "translate(10.785 4.887)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_285",
    "data-name": "Caminho 285",
    d: "M80.271,17.45a4.983,4.983,0,1,1,4.983-4.983,5,5,0,0,1-4.983,4.983m0-7.474a2.491,2.491,0,1,0,2.491,2.491,2.5,2.5,0,0,0-2.491-2.491",
    transform: "translate(18.501 1.839)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_286",
    "data-name": "Caminho 286",
    d: "M104.826,19.784a3.737,3.737,0,1,1-3.737,3.737,3.738,3.738,0,0,1,3.737-3.737",
    transform: "translate(24.841 4.862)",
    fill: "#a1a1a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_287",
    "data-name": "Caminho 287",
    d: "M83.9,26.776l.125.125,4.235,4.235L92.493,26.9a1.579,1.579,0,0,1,2.242,0,1.55,1.55,0,0,1,.125,2.118l-.125.125L90.5,33.378l3.986,3.986a1.579,1.579,0,0,1,0,2.242,1.55,1.55,0,0,1-2.118.125l-.125-.249L88.258,35.5l-3.986,3.986a1.579,1.579,0,0,1-2.242,0,1.55,1.55,0,0,1-.125-2.118l.125-.125,3.986-3.986L81.78,29.018a1.579,1.579,0,0,1,0-2.242,1.692,1.692,0,0,1,1.993-.249Z",
    transform: "translate(19.981 6.465)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_288",
    "data-name": "Caminho 288",
    d: "M2.6,33.052l.123.125,2.616,2.616,2.617-2.616a1.577,1.577,0,0,1,2.241,0,1.55,1.55,0,0,1,.125,2.118l-.125.125L7.585,38.035,10.2,40.651a1.579,1.579,0,0,1,0,2.242,1.548,1.548,0,0,1-2.116.125l-.125-.125L5.342,40.277,2.726,42.893a1.579,1.579,0,0,1-2.242,0A1.548,1.548,0,0,1,.36,40.775l.123-.125,2.742-2.616L.608,35.418a1.581,1.581,0,0,1,0-2.242A1.694,1.694,0,0,1,2.6,32.927Z",
    transform: "translate(0 8.038)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_289",
    "data-name": "Caminho 289",
    d: "M15.626,21.384a3.737,3.737,0,1,1-3.737,3.737,3.738,3.738,0,0,1,3.737-3.737",
    transform: "translate(2.922 5.255)",
    fill: "#a1a1a1",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0b1f435c18ad212e085a14c6e678da5e.svg";
export { ForwardRef as ReactComponent };